export default {
  pt: {
    sloganLine1: "Segurança sem franquia, liberdade sem custo",
    sloganLine2: "Saia da loja segurado",
    activateButton: "Ativar Seguro",
    tutorialButton: "Veja o Tutorial",
    toastTitle: "Não foi possível encontrar o seu cadastro.",
    toastDescription: "Por favor, entre em contato com a BikeHero.",
  },

  en: {
    sloganLine1: "Security without deductible, freedom without cost",
    sloganLine2: "Leave the store insured",
    activateButton: "Activate Insurance",
    tutorialButton: "Watch the Tutorial",
    toastTitle: "It was not possible to find your registration.",
    toastDescription: "Please contact BikeHero.",
  },
}; 